import apiUrl from '../../../constants';
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { bulkDisputeSampleCSV } from '../../../services/externalDispute';
import { fetchClientList } from '../../../services/externalDispute';
import CryptoJS from 'crypto-js';
import { getReasonSubReason } from '../../../services/externalDispute';


export default {
  name: 'DisputeBulkUpload',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data() {
    return {
      show: false,
      myStr: '',
      isLoading1: false,
      bulkCSVData:[],
      username:'',
      attachment:[],
      FileSelected: null,
      bulkDisputeCSVData:[],
      FailedRecords:'',
      FailedRecords:'',
      bulkDisputeCSVDataFlag:false,
      clientList:[],
      client:'',
      userFirstLastName : '',
      shipmentTypeList : ["DTO","RTO","DTODispute","ForwardDispute"],
      dtoReasonSub : [],
      rtoReasonSub : [],
      dtoDisputeReasonSub : [],
      forwardDispReasonSub : [],
      bulkModal : false,
      bulkLoader : false
      //requiredColumns: ["ShippingID","ShipmentType","DisputeAmount","DisputeReason","DisputeSubReason","Comments","UnboxingVideo","PhotoProof-1","PhotoProof-2", "PhotoProof-3", "PhotoProof-4","OtherProof-1","OtherProof-2","DisputeRemark"]

    }
  },
  mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.username = window.localStorage.getItem('username');
    this.fetchClient()
    var userdetailEncrypt = window.localStorage.getItem('accessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userFirstLastName = userdetail.FirstName
    this.reasonSubReason();

  },
  computed: {

  },

  methods: {
    fetchClient(){
      fetchClientList({}, this.myStr).then(client => {
        let clienList = client.data.data;
        this.clientList = clienList.map(client => ({id: client.ClientMasterID, label: client.CompanyName}));
            })
    },
    async exportfileCSV() {
      this.isLoading1 = true;
      let bulkData=await bulkDisputeSampleCSV(this.myStr)
      this.bulkCSVData=bulkData.data.ReturnCSV
      this.downloadCSV(this.bulkCSVData);
    },

    async downloadCSV(result) {
      var csvData = result;
      var data, filename, link;
      filename = "bulkDisputeSampleCSV" +".csv";
      var csv = await this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = csv;
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      lineDelimiter = args.lineDelimiter || "\n";
      columnDelimiter = args.data
      result = "";
      result += columnDelimiter;
      result += lineDelimiter;
      return result;
    },
    onFileChange(e) {
      this.attachment = e.target.files[0];
      this.FileSelected = this.attachment;
      this.FileSelected = null;

    },
    uploadFile() {
            var form = new FormData();
            form.append('file', this.attachment);
            form.append('createdBy', this.username);
            // form.append('ClientID', this.client.id);
            form.append('username',this.userFirstLastName)
            var inputpayload = form;
            this.bulkModal = true
            this.bulkLoader = true
            axios({
              method: 'post',
              url: `${apiUrl.api_url}uploadBulkDisputeCSV`,
              data: inputpayload,
              headers: {
                'Authorization': 'Bearer ' + this.myStr
              },
            }).then((result) => {
              if (result.data.ReturnCode !== 100) this.$alertify.error(result.data.ReturnMessage);
              if (result.data.ReturnCode === 100){
              this.bulkDisputeCSVData=result.data.FailedRecords
              this.bulkDisputeCSVDataFlag=true
              this.successData=result.data.Success
              this.FailedRecords=result.data.Failures
            }
            this.bulkModal = false
            this.bulkLoader = false
            },
              (error) => {
                this.show = false;
                this.displaytable = false;
                this.bulkModal = false
                this.bulkLoader = false
                console.error(error);
              });

            inputpayload = null;
            this.attachment = null;
            this.FileSelected = null;
    },

    async reasonSubReason() {
      let input = {
        "disputeRaisedType": "Client"
      }
      let taskTypeLength = this.shipmentTypeList.length
      for (let i = 0; i < taskTypeLength; i++) {
        input.taskType = this.shipmentTypeList[i]
        let apiResponse = await getReasonSubReason(input, this.myStr)
        if (apiResponse.data.code == 200){
          let resArray = []
          let reasonSubreasonData = apiResponse.data.data
          let reasonSublength = reasonSubreasonData.length
          for (let i = 0; i < reasonSublength; i++) {
            reasonSubreasonData[i].subReason.forEach((sub) => {
              resArray.push({
                reason: reasonSubreasonData[i].reason,
                subreason: sub.subReason
              });
            })
          }
          if (input.taskType == 'DTO'){
            this.dtoReasonSub = resArray
          }else if (input.taskType == 'RTO'){
            this.rtoReasonSub = resArray
          }else if (input.taskType == 'DTODispute'){
            this.dtoDisputeReasonSub = resArray
          }else if (input.taskType == 'ForwardDispute'){
            this.forwardDispReasonSub = resArray
          }
        }else{
          this.$alertify.error("Dispute Reason Subreason error");
        }

      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/DisputeBulkUpload/DisputeBulkUpload.component.js